function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PanoNoticeBar from 'pano-notice-bar'; // import PanoNoticeBar from '@/components/pano-notice-bar/src';

var MultiNoticeBar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MultiNoticeBar, _React$PureComponent);

  var _super = _createSuper(MultiNoticeBar);

  function MultiNoticeBar() {
    var _this;

    _classCallCheck(this, MultiNoticeBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      activity: 0,
      translateY: 0,
      isAnimation: true
    };
    _this.reset = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.asyncSetState({
                activity: 0,
                translateY: 0,
                isAnimation: false
              });

            case 2:
              _context.next = 4;
              return _this.sleep(5);

            case 4:
              _context.next = 6;
              return _this.asyncSetState({
                isAnimation: true
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.asyncSetState = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  _this.setState(state, resolve);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.sleep = function (time) {
      return new Promise(function (resolve) {
        setTimeout(resolve, time);
      });
    };

    _this.next = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var data, activity, newActivity, translateY;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = _this.props.data;

              if (!(data.length < 2)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              activity = _this.state.activity;

              if (!(activity === data.length)) {
                _context3.next = 12;
                break;
              }

              _context3.next = 7;
              return _this.asyncSetState({
                activity: 0,
                translateY: 0,
                isAnimation: false
              });

            case 7:
              _context3.next = 9;
              return _this.sleep(5);

            case 9:
              newActivity = 1;
              _context3.next = 13;
              break;

            case 12:
              newActivity = activity + 1;

            case 13:
              translateY = newActivity * -30;

              _this.setState({
                activity: newActivity,
                translateY: translateY,
                isAnimation: true
              });

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    _this.onItemComplete = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.next();

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.onClickText = function (row) {
      var onClick = _this.props.onClick;
      onClick && onClick(row);
    };

    _this.renderItem = function (row, index) {
      var _this$props = _this.props,
          height = _this$props.height,
          baseSpeed = _this$props.baseSpeed,
          data = _this$props.data,
          isPlay = _this$props.isPlay,
          disableClick = _this$props.disableClick;
      var fontSize = row.fontSize,
          fontColor = row.fontColor,
          bgColor = row.bgColor,
          spacing = row.spacing,
          rollingSpeed = row.rollingSpeed,
          rollingMode = row.rollingMode,
          linkTarget = row.linkTarget,
          clickAction = row.clickAction,
          pauseDuration = row.pauseDuration,
          clickActionLink = row.clickActionLink;
      var noticeProps = {
        // target: blank == 1 ? "_blank" : null,
        // url: url === "" ? null : url,
        rollingMode: rollingMode,
        endDelay: pauseDuration * 1000,
        speed: baseSpeed * rollingSpeed,
        style: {
          background: "rgba(".concat(bgColor, ")"),
          height: height,
          // ...barStyle,
          fontSize: fontSize,
          letterSpacing: spacing
        },
        color: "rgba(".concat(fontColor, ")")
      };

      if (clickAction === 1 && !disableClick) {
        noticeProps.isPointer = true; // linkTarget:0弹窗1新窗口2本窗口

        if (linkTarget !== 0) {
          noticeProps.url = clickActionLink;
        }

        if (linkTarget === 1) {
          noticeProps.target = '_blank';
        }

        if (linkTarget === 0) {
          noticeProps.onClick = _this.onClickText.bind(_assertThisInitialized(_this), row);
        }
      }

      var _this$state = _this.state,
          activity = _this$state.activity,
          isAnimation = _this$state.isAnimation;
      return /*#__PURE__*/React.createElement(PanoNoticeBar, _extends({
        bj: index,
        isPlay: index === activity && isAnimation && isPlay,
        key: index
      }, noticeProps, {
        onComplete: _this.onItemComplete.bind(_assertThisInitialized(_this), row),
        loop: data.length === 1
      }), row.text);
    };

    _this.renderCopy = function () {
      var data = _this.props.data;
      var dataLen = data.length;
      if (dataLen <= 1) return;
      var row = data[0];
      return _this.renderItem(row, dataLen);
    };

    return _this;
  }

  _createClass(MultiNoticeBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var data = this.props.data;
      var prevData = prevProps.data;

      if (data !== prevData) {
        this.reset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          height = _this$props2.height;
      var _this$state2 = this.state,
          translateY = _this$state2.translateY,
          isAnimation = _this$state2.isAnimation;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: height,
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          pointerEvents: 'auto',
          transform: "translateY(".concat(translateY, "px)"),
          transition: isAnimation ? 'transform 0.3s linear 0s' : null
        }
      }, data.map(this.renderItem), this.renderCopy()));
    }
  }]);

  return MultiNoticeBar;
}(React.PureComponent);

MultiNoticeBar.defaultProps = {
  baseSpeed: 120,
  height: 30,
  data: [// {
    //   text: "这是一条字幕", // 字幕内容
    //   fontSize: 12, // 文字大小
    //   fontColor: "255,100,1,1", // 文字颜色
    //   bgColor: "0,0,0,0.5", // 背景颜色
    //   spacing: 0, // 字间距
    //   rollingMode: 0, // 0静止显示, 1向左滚动
    //   rollingSpeed: 1.0, // 0.5 - 2.0
    //   pauseDuration: 1, // 停留时长, 单位秒
    //   clickAction: 1, // 0无操作, 1打开超链接
    //   clickActionLink: "https://qq.com", // 超链接
    //   linkTarget: 0,
    // },
    // {
    //   text: "这是另一条字幕", // 字幕内容
    //   fontSize: 14, // 文字大小
    //   fontColor: "255,255,255,1", // 文字颜色
    //   bgColor: "255,0,0,0.5", // 背景颜色
    //   spacing: 1, // 字间距
    //   rollingMode: 2, // 0静止显示, 1向左滚动
    //   rollingSpeed: 2, // 0.5 - 2.0
    //   pauseDuration: 1, // 停留时长, 单位秒
    //   clickAction: 1, // 0无操作, 1打开超链接
    //   clickActionLink: "https://qq.com", // 超链接
    //   linkTarget: 1, // 0弹窗1新窗口2本窗口
    // },
  ]
};
export default MultiNoticeBar;